import Keycloak from 'keycloak-js'
import Api from '../../../common/http/Api'
import { UUID } from 'crypto'
import CreatePayment from '../../../domain/payment/CreatePayment'
import CreateDebt from '../../../domain/payment/CreateDebt'

class PaymentTransactionsApi extends Api {
  private static readonly BASIC_PATH = 'transactions'

  static createDebt = async (
    keycloak: Keycloak,
    studentId: UUID,
    createDebt: CreateDebt,
  ): Promise<void> => {
    const createDebtDto = createDebt.toDto()
    const path = `${PaymentTransactionsApi.BASIC_PATH}/debt/${studentId}`

    await Api.post(path, createDebtDto, keycloak)
  }

  static removeDebt = async (keycloak: Keycloak, id: UUID): Promise<void> => {
    const path = `${PaymentTransactionsApi.BASIC_PATH}/debt/${id}`
    await Api.delete(path)
  }

  static createPayment = async (
    keycloak: Keycloak,
    studentId: UUID,
    createPayment: CreatePayment,
  ): Promise<void> => {
    const createPaymentDto = createPayment.toDto()
    const path = `${PaymentTransactionsApi.BASIC_PATH}/payment/${studentId}`

    await Api.post(path, createPaymentDto, keycloak)
  }

  static removePayment = async (
    keycloak: Keycloak,
    id: UUID,
  ): Promise<void> => {
    const path = `${PaymentTransactionsApi.BASIC_PATH}/payment/${id}`
    await Api.delete(path)
  }
}

export default PaymentTransactionsApi
